import { render, staticRenderFns } from "./AppAssignments.vue?vue&type=template&id=f07f15ee&scoped=true&"
import script from "./AppAssignments.vue?vue&type=script&lang=js&"
export * from "./AppAssignments.vue?vue&type=script&lang=js&"
import style0 from "./AppAssignments.vue?vue&type=style&index=0&id=f07f15ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07f15ee",
  null
  
)

export default component.exports